import React from 'react';

const CardStat = (props) => (
  <p><b>{props.title + ": "}</b>{props.value}</p>
)

export default CardStat;